import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Analytics, layoutActions } from '@Techedge/digitalportal-shared'
import { FILTERS_REDUCER_NAMESPACE } from '../redux/reducers/filters'
import Information from '../components/NewQuickLink/Information/Information'
import { getFiltersDomain, getVisibilities } from '../redux/actions/filters'
import { LuxAccordion, LuxButton, LuxModalFullScreen } from '@lux/wardrobe-lib'
import { AccordionTabProps, DistributionListProps, Visibility } from '../models/new-resource'
import './NewQuickLink.scss'
import { createLink, editLink, getLinksID } from '../redux/actions/new-resource'
import Distribution from '../components/ActivityCreation/Distribution/DistributionList'
import { MenuItem } from 'primereact/menuitem'
import {QUICK_LINK_REDUCER_NAMESPACE} from "@redux/reducers/quick-link";
import {setSmartFilterQuickLink} from "@redux/actions/quick-link";


const NewQuickLink = (props: {
    isEdit: boolean
    accessToken: string
    linkId: string
    visibilityList: any[]
    smartFilter: any
    createLink: (
        body: {
            title: string
            url: string
            description: string
            visibility: Visibility[]
            storeList: string[]
            smartFilter?: any
        },
        textSuccess: string
    ) => void
    getLinksID: (id: string, callback: (data: any) => void) => void
    editLink: (
        body: {
            title: string
            url: string
            description: string
            visibility: Visibility[]
            storeList: string[]
            smartFilter?: any
        },
        linkId: string,
        text: string
    ) => void
    onClose: () => void
    getVisibilities: () => void
    getFiltersDomain?: () => void
    setSmartFilter: (value: any) => void
}) => {
    const {
        isEdit,
        accessToken,
        linkId,
        visibilityList,
        createLink,
        editLink,
        onClose,
        getVisibilities,
        getLinksID,
        getFiltersDomain,
        smartFilter,
        setSmartFilter
    } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-quick-link'

    const [linkTitle, setLinkTitle] = useState<string>('')
    const [linkURL, setLinkURL] = useState<string>('')
    const [linkDescription, setLinkDescription] = useState<string>('')
    const [visibility, setVisibility] = useState<Visibility[]>([])
    const [saveDisabled, setSaveDisabled] = useState<boolean>(true)
    const [distributionList, setDistributionList] = useState<DistributionListProps>({
        listName: {
            value: '',
        },
        selectedStoreList: {
            value: [],
            mandatory: true,
        },
        selectedDistributionList: {
            value: [],
        },
    })

    // USE EFFECTS

    useEffect(() => {
        Analytics._sendAnalyticsLinkEvent('Quicklinks', 'Creation', 'Static')
    }, [])

    useEffect(() => {
        if (accessToken) {
            getVisibilities()
            getFiltersDomain()
        }
    }, [accessToken])

    useEffect(() => {
        if (isEdit && linkId) {
            getLinksID(linkId, (data: any) => {
                if (data?.quicklinks?.length === 1) {
                    let quickLink = data?.quicklinks[0]

                    setLinkTitle(quickLink?.title),
                        setLinkURL(quickLink?.url),
                        setLinkDescription(quickLink?.description),
                        setVisibility(quickLink?.visibility),
                        setSmartFilter(quickLink?.smartFilter)
                        setDistributionList({
                            ...distributionList,
                            selectedStoreList: {
                                ...distributionList.selectedStoreList,
                                value: quickLink?.storeList.map((s: string) => {
                                    return { store_id: s }
                                }),
                            },
                        })
                }
            })
        }

        return () => {
            setSmartFilter({})
        }
    }, [])

    useEffect(() => {
        if (
            linkTitle.length === 0 ||
            linkURL.length === 0 ||
            visibility.length === 0 ||
            distributionList.selectedStoreList.value.length === 0
        ) {
            setSaveDisabled(true)
        } else {
            setSaveDisabled(false)
        }
    }, [linkTitle, linkURL, linkDescription, visibility, distributionList])

    // FUNCTIONS

    const accordionTabs: AccordionTabProps[] = [
        {
            title: intl.formatMessage({
                id: 'modals.new_resource.accordion_tab.title.information',
                defaultMessage: 'Information',
            }),
            content: (
                <Information
                    isEdit={isEdit}
                    linkTitle={linkTitle}
                    setLinkTitle={setLinkTitle}
                    linkURL={linkURL}
                    setLinkURL={setLinkURL}
                    visibility={visibility}
                    setVisibility={setVisibility}
                    visibilityList={visibilityList}
                    linkDescription={linkDescription}
                    setLinkDescription={setLinkDescription}
                />
            ),
            disabled: false,
        },

        {
            title: intl.formatMessage({
                id: 'modals.new.activity.section.distribution',
                defaultMessage: 'Distribution',
            }),
            content: (
                <Distribution
                    tableConfigId={'quick_links_editing'}
                    form={distributionList}
                    onSetForm={(form: any) => {
                        setDistributionList((value: any) => ({
                            ...value,
                            ...form,
                        }))
                    }}
                    onSave={() => null}
                    disableHeaderActions={false}
                    smartFilter={smartFilter}
                    setSmartFilter={setSmartFilter}
                />
            ),
            disabled: false,
        },
    ]

    //breadcrumb names set here
    const breadcrumbs: MenuItem[] = [
        {
            label: intl.formatMessage({
                id: 'modals.quick_links.title',
                defaultMessage: 'Quick Links',
            }),
        },
        {
            label: isEdit
                ? intl.formatMessage({
                      id: 'modals.edit_quick_links.title',
                      defaultMessage: 'Edit Quick Link',
                  })
                : intl.formatMessage({
                      id: 'modals.new_quick_links.title',
                      defaultMessage: 'New Quick Link',
                  }),
            disabled: true,
        },
    ]

    const expandedVisibility = () => {
        let newVisibiliy = []
        let tmpVisibility = [...visibility]
        if (tmpVisibility?.length > 0) {
            for (let i = 0; i < tmpVisibility.length; i++) {
                let v = tmpVisibility[i]
                switch (v) {
                    case Visibility.gatekeeper:
                        if (!newVisibiliy.includes(Visibility.gatekeeper)) {
                            newVisibiliy.push(Visibility.gatekeeper)
                        }
                        break
                    case Visibility.creator:
                        if (!newVisibiliy.includes(Visibility.gatekeeper)) {
                            newVisibiliy.push(Visibility.gatekeeper)
                        }
                        if (!newVisibiliy.includes(Visibility.creator)) {
                            newVisibiliy.push(Visibility.creator)
                        }
                        break
                    case Visibility.regionalmanager:
                        if (!newVisibiliy.includes(Visibility.gatekeeper)) {
                            newVisibiliy.push(Visibility.gatekeeper)
                        }
                        if (!newVisibiliy.includes(Visibility.creator)) {
                            newVisibiliy.push(Visibility.creator)
                        }
                        if (!newVisibiliy.includes(Visibility.regionalmanager)) {
                            newVisibiliy.push(Visibility.regionalmanager)
                        }
                        break
                    case Visibility.storemanager:
                        if (!newVisibiliy.includes(Visibility.gatekeeper)) {
                            newVisibiliy.push(Visibility.gatekeeper)
                        }
                        if (!newVisibiliy.includes(Visibility.creator)) {
                            newVisibiliy.push(Visibility.creator)
                        }
                        if (!newVisibiliy.includes(Visibility.regionalmanager)) {
                            newVisibiliy.push(Visibility.regionalmanager)
                        }
                        if (!newVisibiliy.includes(Visibility.storemanager)) {
                            newVisibiliy.push(Visibility.storemanager)
                        }
                        break
                    case Visibility.optemployeed:
                        if (!newVisibiliy.includes(Visibility.optemployeed)) {
                            newVisibiliy.push(Visibility.optemployeed)
                        }
                        if (!newVisibiliy.includes(Visibility.gatekeeper)) {
                            newVisibiliy.push(Visibility.gatekeeper)
                        }
                        if (!newVisibiliy.includes(Visibility.creator)) {
                            newVisibiliy.push(Visibility.creator)
                        }
                        if (!newVisibiliy.includes(Visibility.regionalmanager)) {
                            newVisibiliy.push(Visibility.regionalmanager)
                        }
                        if (!newVisibiliy.includes(Visibility.storemanager)) {
                            newVisibiliy.push(Visibility.storemanager)
                        }
                        break
                    case Visibility.optindependent:
                        if (!newVisibiliy.includes(Visibility.optindependent)) {
                            newVisibiliy.push(Visibility.optindependent)
                        }
                        if (!newVisibiliy.includes(Visibility.gatekeeper)) {
                            newVisibiliy.push(Visibility.gatekeeper)
                        }
                        if (!newVisibiliy.includes(Visibility.creator)) {
                            newVisibiliy.push(Visibility.creator)
                        }
                        if (!newVisibiliy.includes(Visibility.regionalmanager)) {
                            newVisibiliy.push(Visibility.regionalmanager)
                        }
                        if (!newVisibiliy.includes(Visibility.storemanager)) {
                            newVisibiliy.push(Visibility.storemanager)
                        }
                        break
                    case Visibility.storeassociate:
                        if (!newVisibiliy.includes(Visibility.gatekeeper)) {
                            newVisibiliy.push(Visibility.gatekeeper)
                        }
                        if (!newVisibiliy.includes(Visibility.creator)) {
                            newVisibiliy.push(Visibility.creator)
                        }
                        if (!newVisibiliy.includes(Visibility.regionalmanager)) {
                            newVisibiliy.push(Visibility.regionalmanager)
                        }
                        if (!newVisibiliy.includes(Visibility.storemanager)) {
                            newVisibiliy.push(Visibility.storemanager)
                        }
                        if (!newVisibiliy.includes(Visibility.storeassociate)) {
                            newVisibiliy.push(Visibility.storeassociate)
                        }
                        break
                    default:
                        break
                }
            }
        }
        return newVisibiliy
    }

    const onSave = () => {
        isEdit
            ? editLink(
                  {
                      title: linkTitle,
                      url: linkURL,
                      description: linkDescription,
                      smartFilter: smartFilter,
                      visibility: expandedVisibility(),
                      storeList: distributionList.selectedStoreList.value.map((s: any) => {
                          return s.store_id
                      }),
                  },
                  linkId,
                  intl.formatMessage({
                      id: 'link_successfully_edited',
                      defaultMessage: 'Link successfully edited',
                  })
              )
            : createLink(
                  {
                      title: linkTitle,
                      url: linkURL,
                      description: linkDescription,
                      smartFilter: smartFilter,
                      visibility: expandedVisibility(),
                      storeList: distributionList.selectedStoreList.value.map((s: any) => {
                          return s.store_id
                      }),
                  },
                  intl.formatMessage({
                      id: 'link_successfully_created',
                      defaultMessage: 'Link successfully created',
                  })
              )
    }

    const footer = (
        <div className={`${componentClass}__footer`}>
            <LuxButton
                onClick={onSave}
                disabled={saveDisabled}
                text={intl.formatMessage({
                    id: 'modals.dialog.buttons.save',
                    defaultMessage: 'Save',
                })}
            />
        </div>
    )

    return (
        <div className={componentClass}>
            <LuxModalFullScreen
                footer={footer}
                onClose={onClose}
                hideSidebar={true}
                breadcrumbMenu={breadcrumbs}
                labelHeaderMobile={
                    isEdit
                        ? intl.formatMessage({
                              id: 'modals.edit_quick_links.title',
                              defaultMessage: 'Edit Quick Link',
                          })
                        : intl.formatMessage({
                              id: 'modals.new_quick_links.title',
                              defaultMessage: 'New Quick Link',
                          })
                }>
                <div className={`${componentClass}__content`}>
                    <div className={`${componentClass}__content__accordions`}>
                        {accordionTabs?.length > 0 &&
                            accordionTabs
                                ?.filter((t: AccordionTabProps) => {
                                    return !t.disabled
                                })
                                ?.map((t: AccordionTabProps, i: number) => {
                                    return (
                                        <LuxAccordion
                                            key={i}
                                            title={t.title}
                                            activeIndex={i}>
                                            {t.content}
                                        </LuxAccordion>
                                    )
                                })}
                    </div>
                </div>
            </LuxModalFullScreen>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    accessToken: state.userReducer.accessToken,
    storesList: state[FILTERS_REDUCER_NAMESPACE].storesList,
    visibilityList: state[FILTERS_REDUCER_NAMESPACE].visibilityList,
    linkId: state.layoutReducer.modals.props?.id,
    isEdit: state.layoutReducer.modals.props?.isEdit,
    smartFilter: state[QUICK_LINK_REDUCER_NAMESPACE].smartFilter,
})

const mapDispatchToProps = (dispatch: any) => ({
    getFiltersDomain: () => dispatch(getFiltersDomain()),
    getVisibilities: () => {
        dispatch(getVisibilities())
    },
    getLinksID: (id: string, callback: (data: any) => void) => {
        dispatch(getLinksID(id, callback))
    },

    createLink: (
        body: {
            title: string
            url: string
            description: string
            visibility: Visibility[]
            storeList: string[]
        },
        text: string
    ) => dispatch(createLink(body, text)),
    editLink: (
        body: {
            title: string
            url: string
            description: string
            visibility: Visibility[]
            storeList: string[]
            smartFilter?: any
        },
        linkId: string,
        text: string
    ) => dispatch(editLink(body, linkId, text)),
    onClose: () => {
        dispatch(
            layoutActions.setModals({
                type: null,
                props: {
                    id: null,
                    storeIdList: null,
                    isEdit: false,
                    isClone: false,
                },
            })
        )
    },
    setSmartFilter: (value: any) => dispatch(setSmartFilterQuickLink(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewQuickLink)
